import { IComputedVueType } from "./IComputedVueType";
import { IFilter } from "./IFilter";
import { IQueryOptions } from "./IQueryOptions";
import { PageSize } from "./PageSize";
import { pageSizes } from "./pageSizes";

export function getComputed<TFilter extends IFilter = IFilter & Record<string, unknown>>(): IComputedVueType<TFilter> {
  return {
    pageSize: {
      get(this: IQueryOptions<TFilter>): PageSize {
        const pageSize = pageSizes.find(pageSize => this.queryOptions.page?.size === +pageSize.id) as PageSize;

        return pageSize;
      },
      set(this: IQueryOptions<TFilter>, item: PageSize): void {
        if (item) {
          this.queryOptions.page.size = +item.id;
        }
      },
    },

    filterClasses(this: IQueryOptions<TFilter>): string[] {
      if (!this.filter) {
        return [];
      }

      const classes = Object.keys(this.filter)
        .filter(k => k !== "id")
        .map(key => key);
      return classes;
    },
  };
}
